'use client';

import React, { FC } from 'react';
import { CatHeading } from 'components/blocks-components';
import { AltPartAttribute } from 'services/product/types';
import { useTranslations } from 'next-intl';
import cx from 'classnames';
import styles from '../alternate-parts.module.scss';
import { PAGE_BREAKPOINTS } from '@cat-ecom/pcc-components/src/constants/commonConstants';
import { useBreakpoint } from '@cat-ecom/pcc-components';

interface AlternatePartSectionsProps {
  attributes: AltPartAttribute[];
  currentSpecs: AltPartAttribute[];
  shortDescription: string;
  defaultUom: string;
}

const AlternatePartSections: FC<AlternatePartSectionsProps> = ({
  attributes,
  currentSpecs,
  shortDescription,
  defaultUom
}) => {
  const t = useTranslations();
  const isDesktop = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const specifications = attributes
    ?.filter((attribute) => attribute.uom === defaultUom)
    .slice(0, 3);

  const currentItemSpecifications = currentSpecs
    ?.filter((attribute) => attribute.uom === defaultUom)
    .slice(0, 3);

  const commonSpecsStyle = cx(
    'd-flex',
    {
      'flex-column justify-content-center align-items-start': !isDesktop,
      'align-items-center': isDesktop
    },
    styles['section-with-background'],
    styles['spec']
  );

  return (
    <>
      {currentItemSpecifications?.length > 0 && (
        <>
          {currentItemSpecifications.map((currrentSpec, index) => {
            if (currrentSpec?.name) {
              return (
                <section
                  key={`spec${index + 1}`}
                  id={`spec${index + 1}`}
                  className={commonSpecsStyle}
                >
                  {!isDesktop && (
                    <CatHeading
                      variant="label-sm"
                      className={`${styles['spec__heading']}`}
                    >
                      {specifications[index]?.name}
                    </CatHeading>
                  )}
                  <p className="cat-u-theme-typography-body-sm m-0">
                    {specifications[index]?.value}
                  </p>
                </section>
              );
            }
          })}
        </>
      )}
      <section
        id="desc"
        className={`d-flex flex-column align-items-start ${styles['section-with-background']} ${styles['desc']}`}
      >
        {!isDesktop && shortDescription && (
          <CatHeading variant="label-sm">{t('DESCRIPTION')}</CatHeading>
        )}
        <p className="cat-u-theme-typography-footnote m-0">
          {shortDescription}
        </p>
      </section>
    </>
  );
};

export default AlternatePartSections;
